import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'

const Tab = styled.div`
  flex: 1;
  font-family: 'Avenir-Heavy';
  text-transform: uppercase;
  font-size: 16px;
  color: var(--txt);
  transition: all 0.2s ease-in-out;

  @media (min-width: 1200px) {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .theme-dark & {
    background-color: #0f1012;
    color: #f6e0a0;
    text-shadow: 0 0 12px rgba(245, 197, 66, 0.18);
  }
  .theme-light & {
    background-color: #e0e0ec;
  }
  svg {
    transition: all 0.2s ease-in-out;
    fill: var(--txt);
  }
  &.active {
    color: var(--txt);
    background-color: transparent;
    svg {
      fill: var(--txt);
    }
  }
`

interface TabsProps {
  activeTab: number
  hideModal: () => void
}

const Tabs = ({ activeTab, hideModal }: TabsProps) => {
  const { t } = useTranslation('walletManagement')

  return (
    <div className="w-full flex h-10 xl:h-[50px]">
      <Tab className="flx-ctr">
        {activeTab === 0 ? t('deposit') : t('withdrawal')}

        <button
          className="absolute w-[45px] h-10 xl:h-[50px] right-0 top-0 flx-ctr bg-highlight xl:rounded-tr-[10px]"
          onClick={hideModal}
          aria-label="Close modal">
          <Icon
            className="!fill-white w-3.5 h-3.5"
            id="close"
            width={12}
            height={12}
          />
        </button>
      </Tab>
    </div>
  )
}

export default Tabs
